import { render } from "./communitiesListing.vue?vue&type=template&id=4477c57e&scoped=true"
import script from "./communitiesListing.vue?vue&type=script&lang=js"
export * from "./communitiesListing.vue?vue&type=script&lang=js"

import "./communitiesListing.vue?vue&type=style&index=0&id=4477c57e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4477c57e"]])

export default __exports__